const StudioMap = () => (
  <svg
    className='text-white w-6 h-6'
    width='24px'
    height='24px'
    viewBox='0 0 512 512'
    stroke='currentColor'
    fill='#f4f4f4'
  >
    <path
      d='M208.938,331.094l11.875,29.688c-11.5,4.594-22.969,8.094-34.156,10.438l-6.531-31.313
	C189.5,337.938,199.188,334.969,208.938,331.094z M113.719,369.438c11.719,3.375,24.063,5.188,36.688,5.375l0.5-32
	c-9.813-0.156-19.344-1.531-28.344-4.125L113.719,369.438z M365.688,313.594c9.219,1.813,18.219,4.969,26.75,9.375l14.688-28.438
	c-11.25-5.781-23.094-9.938-35.25-12.313L365.688,313.594z M298.938,287.344l9.563,30.5c9.781-3.063,19.438-5,28.75-5.75
	l-2.563-31.875C323,281.156,310.969,283.563,298.938,287.344z M247.563,311.406c-3.594,2.25-7.125,4.313-10.594,6.25l15.563,27.938
	c3.906-2.188,7.906-4.5,11.906-7c5.5-3.406,10.875-6.438,16.156-9.125l-14.531-28.5C260.063,304.031,253.875,307.5,247.563,311.406z
	 M336,112c0,13.063-3.125,25.438-8.688,36.313L256,288c0,0-71.875-140.844-72.156-141.438C178.813,136.125,176,124.375,176,112
	c0-44.188,35.813-80,80-80S336,67.813,336,112z M304,112c0-26.5-21.5-48-48-48s-48,21.5-48,48s21.5,48,48,48S304,138.5,304,112z
	 M416,192h-75.063l-16.344,32h68.344l34.531,103.625l-11.031,12.188c11.75,10.625,17.844,20.406,17.875,20.438l3.375-2.031
	L467.594,448H44.375l32.063-96.094c1.125,0.781,2,1.531,3.25,2.313l17-27.063c-3.813-2.406-6.938-4.781-9.688-7L119.063,224h68.375
	c-6.781-13.25-12.125-23.719-16.344-32H96L0,480h512L416,192z'
    />
  </svg>
)

export default StudioMap
